
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule,
    DxFormItem,
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';

import EstatusService from '../services/estatus-service';
import CotizacionServicioService from '../services/cotizacionservicio-service';




export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule,
        DxFormItem,
    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            dataSourceEstatus: null,
            dataSourceCotizacionServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Cotizacion Servicio',
                showTitle: true,
                width: 400,
                height: 600,
            },



        };
    },
    created() {

        this.cotizacionservicioService = new CotizacionServicioService();
        this.estatusService = new EstatusService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        priceColumn_customizeText(cellInfo) {
            return '$' + cellInfo.value;
        },
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pcotizacionid: id
            });


            this.estatusService.getEstatus().then(data => this.dataSourceEstatus = data.data);

            this.cotizacionservicioService.getCotizacionServicio(myJSON).then(data => this.dataSourceCotizacionServicio = data);
        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },


        editRegister(e) {


            let myJSON = JSON.stringify({
                pid: e.data.id,
                pcotizacionid: e.data.cotizacionid,
                psubtotal: e.data.subtotal,
                piva: e.data.iva,
                ptotal: e.data.total,
                pobservaciones: e.data.observaciones,
                pestatusid: e.data.estatusid
            });


            this.cotizacionservicioService.updateCotizacionServicio(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha actualizado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },

        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
